package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.product_general_tab.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.media_center.tabs.media.app_constants.LoadAppConstant
import org.hs_soft.runmynesto.domain.model.home.product.product_item_model.GetProduct
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.sale_group.SaleItem
import org.hs_soft.runmynesto.domain.model.home.template.product_categories.TemplateCategoryModel
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.CustomTextArea
import org.hs_soft.runmynesto.pages.components.DropDownItem

@Composable
fun ProductTabGeneralInfo(
    modifier: Modifier=Modifier,
    windowSizeMode: WindowSizeModeEnum,
    salesGroup: List<SaleItem>?,
    templateCategories: List<TemplateCategoryModel>?,
    selectedSaleGroupId: String?,
    unitSells: List<LoadAppConstant>?,
    updateCodeValue: (String) -> Unit,
    selectedProduct: GetProduct?,
    updateActivation: (Boolean) -> Unit,
    updateReceiptName: (String) -> Unit,
    updateSaleGroup: (String) -> Unit,
    updateTemplateCategory: (String) -> Unit,
    updateUnitSell: (String) -> Unit,
    updateAlternativeArticleName:(String)->Unit,
) {
    Column(
        modifier = modifier
            .fillMaxWidth()
    )
    {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .thenIf(
                    windowSizeMode== WindowSizeModeEnum.Desktop,
                    Modifier.width(Dimen.extraLargeEditTextWidth)
                )
            ,
            verticalAlignment = Alignment.CenterVertically,
        )
        {
            CustomEditText(
                modifier = Modifier,
                isRequired = false,
                hint = "",
                isOutlinedEditText = true,
                value = selectedProduct?.code?:"",
                marginRight = Dimen.normalPadding,
                marginBottom =Dimen.largePadding ,
                width =
                    if (windowSizeMode== WindowSizeModeEnum.Desktop)
                        Dimen.semiLargeEditTextWidth
                    else Dimen.highNormalEditTextWidth,
                label = Strings.current().number,
                onFocusIn = {},
                onFocusOut = {
                    updateCodeValue(it)
                },
                onInputChange = {it, validation ->

                },
            )


            CheckboxComponent(
                modifier = Modifier
                    .margin(bottom = Dimen.normalPadding) ,
                checkStatus = selectedProduct?.isActive ?: false,
                title = Strings.current().activate,
                onChecked = {
                    updateActivation(true)
                },
                onUnChecked = {
                    updateActivation(false)
                },
                fontWeight = FontWeight.Medium,

                )
        }

        CustomEditText(
            modifier = Modifier,
            width = when(windowSizeMode){
                WindowSizeModeEnum.Desktop->Dimen.extraLargeEditTextWidth
                else->Dimen.semiLargeEditTextWidth
            },
            value =selectedProduct?.name ?: "",
            fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
            label = Strings.current().name,
            isRequired = false,
            hint = "",
            isOutlinedEditText = true,
            onFocusIn = {},
            onFocusOut = {
                updateReceiptName(it)
            },
            onInputChange = {it, validation ->

            },
        )


        DropDownItem(
            modifier = Modifier
                .margin(bottom = Dimen.highLargePadding),
            options = salesGroup ?: listOf(),
            fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
            label = Strings.current().salesGroups,
            itemWidth = Dimen.semiLargeEditTextWidth,
            selectedItem = salesGroup?.find {
                    it.id == selectedSaleGroupId
            },
            displayText = {
                if (it is SaleItem)
                    it.acountNum+" | "+it.name else ""
            },
            onOptionClick = {
                if (it is SaleItem)
                    updateSaleGroup(it.id)
            },
        )
        //------------------------------------------------------
        DropDownItem(
            modifier = Modifier
                .margin(bottom = Dimen.highLargePadding),
            options =templateCategories?:listOf(),
            fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
            label = Strings.current().template,
            itemWidth = Dimen.semiLargeEditTextWidth,
            selectedItem =templateCategories?.find {
                it.id==selectedProduct?.categoryId
            },
            displayText = {
                if (it is TemplateCategoryModel)
                    "${it.position} | ${it.name}"
                else ""
            },
            onOptionClick = {
                if (it is TemplateCategoryModel)
                    updateTemplateCategory(it.id)
            },
        )

        DropDownItem(
            modifier = Modifier,
            options =unitSells?:listOf(),
            fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
            label = Strings.current().salesUnit,
            itemWidth = Dimen.semiLargeEditTextWidth,
            selectedItem =unitSells?.find {
                 it.value==selectedProduct?.unitSellCode
            },
            displayText = {
                if (it is LoadAppConstant)
                    it.label?:"" else ""
            },
            onOptionClick = {
                if (it is LoadAppConstant)
                    updateUnitSell(it.value?:"")
            },
        )

        CustomTextArea(
            modifier = Modifier
                .margin(top = Dimen.highLargePadding),
            fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
            height = Dimen.mediumTextAreaHeight,
            label =Strings.current().altName ,
            value =selectedProduct?.altName?:"" ,
            onValueChange ={} ,
            onFocusOut = {
                updateAlternativeArticleName(it)
            }
        )




    }
}